import React from 'react'

const FBDashboard = () => {
  return (
    <div>FBDashboard</div>
  )
}

export default FBDashboard